import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import ActivityRulesModalStore from './store';

const styles = require('./index.less');

const ActivityRulesModal = ({ store, onClose }) => {
  store.use();
  store.onClose = onClose;

  return (
    <ModalContainer modalState={store.isOpen}>
      <section className={styles.panel} role="dialog" aria-modal="true" aria-label="活动说明">
        <h2 className={styles.title}>活动说明</h2>
        <button className={styles.close} type="button" aria-label="关闭活动说明" onClick={store.onClickClose}>
          ×
        </button>
        <div className={styles.content}>
          <section className={styles.ruleGroup}>
            <h3>一、新服预约</h3>
            <p>活动时间：10月8日-11月16日23:59</p>
            <p>
              ·通过绑定身份证和手机验证的大侠，可在新服<strong>【{store.serverName}】</strong>开服后领取
              <strong>35万绑金+云游戏1小时时长。</strong>
            </p>
            <p>同1个绑定身份证或绑定手机下仅可验证1个账号，一经验证不可取消。</p>
          </section>

          <section className={styles.ruleGroup}>
            <h3>二、特惠礼包</h3>
            <p>特惠价时间：10月8日-10月13日18:00</p>
            <p>补买价时间：10月13日18:01-11月16日23:59</p>
            <p>
              特惠、补买时间所购礼包内容相同，但价格不同，<strong>补买价格高于特惠价格</strong>（钜惠团购礼包价格不变）。
            </p>
            <p>
              ·钜惠组队礼包、特惠礼包、超值礼包、精致礼包、豪华礼包、尊享礼包、雷霆印礼包·壹、雷霆印礼包·贰和雷霆印礼包·叁九种超值礼包，登录账号后即可购买。
              <strong>每个账号每种礼包限购1次</strong>，同种礼包多次购买为无效购买，因超低折扣不予退款，请谨慎购买！
            </p>
            <p>
              ·钜惠组队礼包两人组队购买，可额外获得<strong>御赐仙鹤绣金囊[18格]</strong>奖励！大侠点击“创建购买队伍”购买成功后，将生成专属邀请链接，分享好友，好友通过邀请链接“加入购买队伍”完成购买，即两人组队购买成功。
            </p>
            <p>·未完成实名认证的账号请“点击”完成实名认证后参与购买；如遇支付码失效，可稍作等待后刷新页面再尝试支付。</p>
            <p>·支付订单有效期2分钟，有效期内不可切换双端支付。</p>
          </section>

          <section className={styles.ruleGroup}>
            <h3>三、领奖说明</h3>
            <p>领奖时间：10月13日-11月19日23:59</p>
            <p>礼包有效期截止：11月30日23:59</p>
            <p>
              领奖方式：新服<strong>【{store.serverName}】</strong>点击游戏画面顶部“开服狂欢”-“百万绑金”和“预约好礼”界面领取。
            </p>
            <p>·参与新服预约、购买特惠礼包的账号，限在领奖时间内激活账号下1个角色领取对应奖励，激活角色唯一。</p>
            <p>·通过此活动获得的绑金将根据开服天数和等级进行分次领取。</p>
            <p>
              ·奖励内容均为绑定，不支持更换账号及角色领取，且限账号下1个角色领取。当角色确认领取后，绑金及礼包的领取资格将不可更换，每种礼包最多领取1次，不可多次领取，未领取完奖励的大侠请不要进行角色交易，会导致奖励无法领取，且不作退还！
            </p>
          </section>

          <p className={styles.footer}>以上内容仅供参考，具体以游戏内实际情况为准！</p>
        </div>
      </section>
    </ModalContainer>
  );
};

export { ActivityRulesModalStore };
export default wrapStore(ActivityRulesModal, ActivityRulesModalStore);
